import * as types from "../actions/ActionTypes";
import InitialState from "./InitialState";

export default function utilizationReducer(state = InitialState.profile, action) {

  switch (action.type) {
    case types.LOAD_USER_PROFILE_SUCCESS:
      return { ...action.profile, ghost: state.ghost };
    case types.SET_GHOST_USER:
      return { ...state, ghost: action.userToGhost
        , ghostEmployeeType: action.ghostEmployeeType
        , ghostShowOptions: action.ghostShowOptions
        , ghostShowVouchers: action.ghostShowVouchers
        , ghostIsManager: action.ghostIsManager
        , ghostDataEmployeeId: action.ghostDataEmployeeId
        , ghostPtoEmployeeId: action.ghostPtoEmployeeId
      };
    case types.TOGGLE_DARK_THEME:
      let profile = {
        ...state,
        settings: { ...state.settings, useDarkTheme: action.useDarkTheme },
      };
      localStorage.setItem("settings", JSON.stringify(profile.settings));
      return profile;
    default:
      return state;
  }
}
